'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserAvatar = require('../../../components/userAvatar/UserAvatar');

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _UserName = require('../../../components/userAvatar/UserName');

var _UserName2 = _interopRequireDefault(_UserName);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _referralUtil = require('../../../../common/referrals/referralUtil');

require('./ReferralList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReferralUser = function ReferralUser(_ref) {
    var user = _ref.user;
    return _react2.default.createElement(
        'span',
        { className: 'ReferralDescription' },
        _react2.default.createElement(_UserAvatar2.default, { user: user }),
        _react2.default.createElement(_UserName2.default, { user: user })
    );
};

var ReferralDescription = function ReferralDescription(_ref2) {
    var referral = _ref2.referral;
    return _react2.default.createElement(
        'span',
        { className: 'ReferralDescription' },
        _react2.default.createElement(
            'span',
            { className: 'name' },
            referral.get('description') || 'Bonus cards'
        )
    );
};

var Referral = function Referral(_ref3) {
    var referral = _ref3.referral,
        user = _ref3.user;
    return _react2.default.createElement(
        'li',
        null,
        user ? _react2.default.createElement(ReferralUser, { user: user }) : _react2.default.createElement(ReferralDescription, { referral: referral }),
        _react2.default.createElement(
            'span',
            { className: 'status' },
            _react2.default.createElement(_Icon2.default, { name: 'tick' }),
            (0, _referralUtil.getReferralBonus)(referral),
            ' extra cards'
        )
    );
};

ReferralUser.propTypes = ReferralDescription.propTypes = Referral.propTypes = {
    referral: _propTypes2.default.object,
    user: _propTypes2.default.object
};

var ReferralList = function ReferralList(_ref4) {
    var referrals = _ref4.referrals,
        users = _ref4.users;

    if (!referrals || !referrals.size) return null;

    return _react2.default.createElement(
        'div',
        { className: 'ReferralList' },
        _react2.default.createElement(
            'h3',
            null,
            'Your referrals:'
        ),
        _react2.default.createElement(
            'ul',
            null,
            referrals.filter(function (referral) {
                return referral.get('status') === 'ACTIVE';
            }).map(function (referral) {
                var userId = referral.get('userId');
                var user = users.get(userId);

                return _react2.default.createElement(Referral, { referral: referral, user: user, key: referral.get('_id') });
            })
        )
    );
};

ReferralList.propTypes = {
    referrals: _propTypes2.default.object,
    users: _propTypes2.default.object
};

exports.default = ReferralList;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/referral/ReferralList.js
// module id = 2079
// module chunks = 0